import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import core, { App, Poller } from '@gin-betting/core';

import { SKIP_MATCH_LIST_INITIAL_REQUEST, MatchListType } from 'app-constants';
import matchList from 'modules/match-list';
import { checkSkipPollerConfiguration } from 'utils';

const {
    poller: { withPolling },
} = core;

const {
    actions: { searchMatches },
    selectors: { selectFetchStatus },
    components: { MatchListContainer },
} = matchList;

interface MappedProps {
    fetchStatus: App.FetchStatus;
}

type Props = MappedProps & {
    poller: Poller.Poller<typeof searchMatches>;
};

class Prematch extends React.Component<Props> {
    render() {
        const { fetchStatus, poller } = this.props;

        return (
            <MatchListContainer
                type={MatchListType.PREMATCH}
                fetchStatus={fetchStatus}
                poller={poller}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    fetchStatus: selectFetchStatus,
});

export default compose(
    connect<MappedProps>(mapStateToProps),
    withPolling({
        pollerName: App.PollerName.Prematch,
        executableAction: searchMatches,
        skipInitialRequest: checkSkipPollerConfiguration(
            SKIP_MATCH_LIST_INITIAL_REQUEST[App.Routes.PREMATCH]
        ),
    })
)(Prematch);
